import { forwardRef, type Ref, type SVGProps } from "react";
const IconLivingRoomFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M26.581 10.561c1.336 0 2.419 1.043 2.419 2.33v14.235c0 .483-.406.874-.907.874-.5 0-.907-.391-.907-.874v-2.582H4.814v2.582c0 .483-.406.874-.907.874-.5 0-.907-.391-.907-.874V12.892c0-1.287 1.083-2.33 2.419-2.33h.604V6.33C6.023 5.043 7.106 4 8.442 4h15.72c1.336 0 2.42 1.043 2.42 2.33zm-19.046 8.53c0-.483.406-.874.907-.874h14.663c.5 0 .907.391.907.874 0 .482-.406.874-.907.874H8.442c-.5 0-.907-.392-.907-.874"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLivingRoomFilledSVG);
ForwardRef.displayName = "IconLivingRoomFilled";
export { ForwardRef as IconLivingRoomFilled };
